export const categoryitem = (obj) => {
	return `
        <a class="category__card__item" href="${obj.link}">
            <div class="category__card__content">
                <div class="category__card__title__container">
                    <span class="material-icons-outlined notranslate menu-icon"></span><span class="category__card__title">${obj.title}</span>
                </div>
                <p class="category__card__text">${obj.description}</p>
            </div>
        </a>
    `;
};
